<div [formGroup]="form">
    <div class="row mt-2">        
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{ 'CATALOGO.DATOS_ADICIONALES.FECHA_EFECTO' | translate }}</ca-label>
                <ca-datepicker 
                    formControlName="fEfecto" 
                    name="fEfecto"></ca-datepicker>
                <ca-error *ngIf="form.controls['fEfecto'].errors?.pattern">{{'ERROR.ERROR_FORMATO_FECHA' | translate}}</ca-error>
                <ca-error *ngIf="form.controls['fEfecto'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
       </div>
        <div *ngIf="fraccionamientos?.length > 0" class="col-4">
            <ca-form-field>
                <ca-label>{{'CATALOGO.DATOS_ADICIONALES.FRACCIONAMIENTO' | translate}}</ca-label>
                <ca-select 
                    [options]="fraccionamientos" 
                    formControlName="codFrac" 
                    keyValue="descFraccionamiento"
                    valueField="codigoFraccionamiento"></ca-select>
                <ca-error *ngIf="form.controls['codFrac'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
        </div>
    </div>  
</div>